// src/Pages/ContactPage.js
/* import React from 'react';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-purple-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-2xl p-8 md:p-12 border border-gray-100">
        <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-10 drop-shadow-sm">Get in Touch</h2>
        <p className="text-lg text-gray-700 text-center mb-8">
          Have a project in mind or want to learn more about our services? We'd love to hear from you!
        </p>

        <form className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              Your Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="John Doe"
              required
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="you@example.com"
              required
            />
          </div>
          <div>
            <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
              Subject
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="Inquiry about custom development"
              required
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
              Your Message
            </label>
            <textarea
              id="message"
              name="message"
              rows="5"
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="Tell us about your project or question..."
              required
            ></textarea>
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl border-2 border-blue-600 hover:border-blue-800"
            >
              Send Message
            </button>
          </div>
        </form>

        <div className="mt-12 text-center text-gray-700">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h3>
          <p className="mb-2">
            <span className="font-semibold">Email:</span> <a href="mailto:info@celeritytechnocrats.com" className="text-blue-600 hover:underline">contact@celeritytec.com</a>, <a href="mailto:info@celeritytechnocrats.com" className="text-blue-600 hover:underline">celeritytechnocrats@gmail.com</a>
          </p>
          <p className="mb-2">
            <span className="font-semibold">Phone:</span> +1 (609) 455-2845 (USA) | +44 (0) 78 240 65669 (UK)
          </p>
          <p className="mb-2">
            <span className="font-semibold">Address:</span> Global Offices in USA, UK, Canada, India
          </p>
          <p className="text-sm text-gray-500 mt-4">
            We look forward to partnering with you!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
*/

import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

// Target email for the backend service: celeritytechnocrats@gmail.com

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  // Status can be 'idle', 'loading', 'success', 'error'
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  // Use environment variables for security
  const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
  const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const sendCustomEmail = (e) => {
    e.preventDefault();
    setStatus('loading');
    setStatus('');
    setErrorMessage('');

    // Define the email parameters: to, subject, and the custom HTML content
    const emailParams = {
      to_email: 'celeritytechnocrats@gmail.com', // The email address you are sending to
      subject: 'Contact us: ' + formData.subject + ' , ' + formData.name,
      // The content below must match a single variable in your EmailJS template.
      // For this example, let's assume your template has a variable named {{html_content}}
      html_content: `
            <div style="font-family: sans-serif; padding: 20px; border: 1px solid #eee; border-radius: 8px;">
                <h2 style="color: #1e3a8a;">Hi, New Contact Message Received</h2>
                <hr style="border: 0; border-top: 1px solid #eee; margin: 15px 0;">
                <p><strong>From:</strong> ${formData.name}</p>
                <p><strong>Email:</strong> <a href="mailto:${formData.email}">${formData.email}</a></p>
                <p><strong>Subject:</strong> ${formData.subject}</p>
                <hr style="border: 0; border-top: 1px solid #eee; margin: 15px 0;">
                <p><strong>Message:</strong></p>
                <div style="padding: 10px; background-color: #f4f7f9; border-radius: 4px; white-space: pre-wrap;">${formData.message}</div>
                <p style="margin-top: 20px; font-size: 0.9em; color: #6b7280;">This message was automatically generated by the Celerity Technocrats website contact form.</p>
            </div>
      `,
    };
    
    // NOTE: You still need a TEMPLATE_ID in EmailJS configured to accept these variables.
    const TEMPLATE_ID_CUSTOM = process.env.REACT_APP_CUSTOM_TEMPLATE_ID; 

    emailjs.send(SERVICE_ID, TEMPLATE_ID_CUSTOM, emailParams, {
      publicKey: PUBLIC_KEY,
    })
      .then(
        () => {
          setStatus('Custom HTML email sent successfully!');
          setStatus('success');
          setFormData({ name: '', email: '', subject: '', message: '' }); // Clear form
        },
        (error) => {
          setStatus('Failed to send custom HTML email.');
          setStatus('error');
          console.error('EmailJS Failed:', error);
        }
      );
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMessage('');

    const apiUrl = 'http://server.celeritytec.com:3000/api/send-email'; 
    
    // IMPORTANT: In a real deployment, replace 'http://localhost:5000' 
    // with your production backend URL (e.g., 'https://api.yourdomain.com').

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // Send the JSON stringified data
        body: JSON.stringify(formData), 
      });

      // Check for HTTP errors (4xx or 5xx)
      if (!response.ok) {
        // Parse the error message from the backend if available
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
      }

      // Successful response (2xx status)
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' }); // Clear form

    } catch (error) {
      console.error("Email sending failed:", error);
      setErrorMessage(error.message || 'Failed to send message. Please check the server status and try again.');
      setStatus('error');
    }
  };

  const renderStatusMessage = () => {
    switch (status) {
      case 'loading':
        return (
          <div className="flex items-center justify-center text-blue-600 font-semibold p-4 rounded-lg bg-blue-50 shadow-inner">
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Sending your message...
          </div>
        );
      case 'success':
        return (
            <div className="p-4 bg-green-100 text-green-700 font-semibold rounded-lg shadow-md border border-green-300">
                <p className="text-center">
                  &#10003; Message successfully sent! We will respond to your inquiry at **celeritytechnocrats@gmail.com** shortly.
              </p> 
             {/*             <div className="p-4 bg-red-100 text-red-700 font-semibold rounded-lg shadow-md border border-red-300">
              <p className="text-center">
              !! Due to mail server error, can't send email right now! <br></br>We value your precious enquiry, please send your enquiry at **celeritytechnocrats@gmail.com**, and we will revert shortly.
            </p>
            */ }
          </div>
        );
      case 'error':
        return (
          <div className="p-4 bg-red-100 text-red-700 font-semibold rounded-lg shadow-md border border-red-300">
            <p className="text-center">
              &#10060; Error: {errorMessage}
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-purple-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-2xl p-8 md:p-12 border border-gray-100">
        <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-10 drop-shadow-sm">Get in Touch</h2>
        <p className="text-lg text-gray-700 text-center mb-8">
          Have a project in mind or want to learn more about our services? We'd love to hear from you!
        </p>

        {/* Status Message Display */}
        <div className="mb-6">
          {renderStatusMessage()}
        </div>

        {/* Contact Form */}
        <form onSubmit={sendCustomEmail} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              Your Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="John Doe"
              required
              disabled={status === 'loading'}
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="you@example.com"
              required
              disabled={status === 'loading'}
            />
          </div>
          <div>
            <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
              Subject
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="Inquiry about custom development"
              required
              disabled={status === 'loading'}
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
              Your Message
            </label>
            <textarea
              id="message"
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:border-blue-500 sm:text-base transition-all duration-200"
              placeholder="Tell us about your project or question..."
              required
              disabled={status === 'loading'}
            ></textarea>
          </div>
          <div className="text-center">
            <button
              type="submit"
              disabled={status === 'loading' || status === 'success'}
              className={`w-full md:w-auto font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl border-2
                ${status === 'loading'
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-800 text-white'
                }
              `}
            >
              {status === 'loading' ? 'Sending...' : (status === 'success' ? 'Sent!' : 'Send Message')}
            </button>
          </div>
        </form>

        <div className="mt-12 text-center text-gray-700">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h3>
          <p className="mb-2">
            <span className="font-semibold">Email:</span> <a href="mailto:info@celeritytechnocrats.com" className="text-blue-600 hover:underline">contact@celeritytec.com</a>, <a href="mailto:info@celeritytechnocrats.com" className="text-blue-600 hover:underline">celeritytechnocrats@gmail.com</a>
          </p>
          <p className="mb-2">
            <span className="font-semibold">Phone:</span> +1 (609) 455-2845 (USA) | +44 (0) 78 240 65669 (UK)
          </p>
          <p className="mb-2">
            <span className="font-semibold">Address:</span> Global Offices in USA, UK, Canada, India
          </p>
          <p className="text-sm text-gray-500 mt-4">
            We look forward to partnering with you!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
